import { FirebaseError } from '@firebase/util';

export const throwError = (error: unknown, errorMessage?: string): void => {
  if (error instanceof Error) {
    throw new Error(error.message);
  } else if (error instanceof FirebaseError) {
    throw new Error(error.code);
  } else if (typeof error === 'string') {
    throw new Error(error);
  } else if (errorMessage) {
    throw new Error(errorMessage || '');
  } else {
    throw new Error();
  }
};

export const common = 'エラーが発生しました。';
export const browserBack = '前のページには戻れません。';
export const adminCountError = '管理者を0名にすることはできません';

export const authError = {
  tooManyRequests:
    'アカウントが一時的にロックされています。しばらくしてからもう一度お試しください。',
  invalidEmail: '無効なメールアドレスです。',
  userNotFound: 'ユーザーが見つかりません。',
  signInFailed: 'ログインに失敗しました。',
  invalidCredential: 'メールアドレスまたはパスワードに誤りがあります',
  networkRequestFailed: 'メールアドレスまたはパスワードに誤りがあります',
};
